import { useEffect, useState } from 'react';

// Граница мобильного каркаса — 768px, как в макете «Бумаги»
// (docs/redesign/2026-09-04-bumaga/HANDOFF.md, «Мобильный (≤ 768px)»).
export const MOBILE_QUERY = '(max-width: 767px)';

function matches() {
  // В jsdom matchMedia нет — тесты видят десктоп, как и раньше.
  return typeof window !== 'undefined' && typeof window.matchMedia === 'function'
    && window.matchMedia(MOBILE_QUERY).matches;
}

/** true на экране уже 768px; пересчитывается при повороте и смене ширины окна. */
export function useIsMobile() {
  const [mobile, setMobile] = useState(matches);
  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return undefined;
    const mq = window.matchMedia(MOBILE_QUERY);
    const onChange = () => setMobile(mq.matches);
    onChange();
    mq.addEventListener('change', onChange);
    return () => mq.removeEventListener('change', onChange);
  }, []);
  return mobile;
}
